import { AppComponent } from './app/app.component';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import {
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
  Injector,
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from '@shared/components/lib-ngx/ngx-toastr/toastr/toastr.module';
import { TranslocoRootModule } from '@shared/components/zaa-transloco-root/transloco-root.module';
import { AppRoutingModule } from './app/app.routing.module';
import { TuiRootModule } from '@taiga-ui/core';
import { CoreAuthModule } from '@features/auth/core-auth.module';
import {
  AUTHEN_POLICY_HUTECH,
  AUTHEN_POLICY_ROYAL,
  AUTHEN_POLICY_UEF,
} from '@config/authen.config';
import { AppHttpResponseInterceptor } from '@core/interceptors/app-response.interceptor';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { LOGGER } from '@shared/helpers/log/Logger';

const APP_BOOTSTRAP_CONFIG = {
  providers: [
    importProvidersFrom([
      // Core lib modules
      BrowserModule,
      AppRoutingModule,

      CoreAuthModule.forRoot(AUTHEN_POLICY_HUTECH),

      // Global modules
      TranslocoRootModule,
      ToastrModule.forRoot({ timeOut: 3000 }),
      AngularSlickgridModule.forRoot(),
      TuiRootModule,
    ]),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpResponseInterceptor,
      multi: true,
    },
  ],
};

// ✅ Check version for cache busting
function checkVersionAndReload() {
  const versionFile = '/assets/version.json?v=' + Math.random();

  // Chống infinite reload
  if (sessionStorage.getItem('versionChecking')) return;
  sessionStorage.setItem('versionChecking', 'true');

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 5000);

  fetch(versionFile, {
    method: 'GET',
    cache: 'no-store',
    signal: controller.signal,
  })
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then((data) => {
      if (!data?.version) {
        throw new Error('Missing version field');
      }

      const stored = localStorage.getItem('appVersion');

      // Lần đầu hoặc version khác → reload
      if (!stored || stored !== data.version) {
        localStorage.setItem('appVersion', data.version);
        location.reload();
      }
    })
    .catch((err) => {
      console.error('[Version Check] Failed:', err.message);
      // Fallback: tiếp tục chạy app bình thường
    })
    .finally(() => clearTimeout(timeoutId));
}

// Run version check
checkVersionAndReload();


bootstrapApplication(AppComponent, {...APP_BOOTSTRAP_CONFIG, providers: [provideZoneChangeDetection(), ...APP_BOOTSTRAP_CONFIG.providers]})
  .then((appRef) => {
    // ✅ Set injector cho LOGGER
    LOGGER.setInjector(appRef.injector);

    if (isDevMode()) {
      console.group(`Bootstrap Angular application success`);
    }
  })
  .catch((err) => {
    console.error(`Error when bootstrap application: ${err.message}`);
  });
